import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _styled from "styled-components";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useMemo, useCallback, useEffect, useRef, useState } from 'react';
import { Controller } from 'react-hook-form';
import { useOnClickOutside } from 'usehooks-ts';
import { useFloating, offset, flip, autoUpdate } from '@floating-ui/react';
import { TextInput } from '@restworld/ui-ds-base';
import { useGmapsScript } from '@restworld/utils-common';
import { FormLabelWrapper, Title, HelperTextRElement } from '../..';
import { useRenderSuggestions } from './google-auto-complete-input.hooks';
import { DropdownElementWrapper, DropdownWrapper, MainWrapper } from './google-auto-complete-input.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DROPDOWN_OFFSET = 4;
export var GoogleAutoCompleteInput = function GoogleAutoCompleteInput(_ref) {
  var mainLabel = _ref.mainLabel,
      formId = _ref.formId,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      _ref$placesFilterType = _ref.placesFilterTypes,
      placesFilterTypes = _ref$placesFilterType === void 0 ? ['address'] : _ref$placesFilterType,
      _onSuggestionSelect = _ref.onSuggestionSelect,
      title = _ref.title,
      subTitle = _ref.subTitle,
      required = _ref.required,
      testId = _ref.testId,
      formValue = _ref.formValue,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      control = _ref.control,
      helperText = _ref.helperText,
      dropdownTestId = _ref.dropdownTestId,
      inputProps = _ref.inputProps,
      dropdownItemProps = _ref.dropdownItemProps,
      mainWrapperStyle = _ref.mainWrapperStyle,
      dropdownMainWrapperStyle = _ref.dropdownMainWrapperStyle,
      dropdownSubWrapperStyle = _ref.dropdownSubWrapperStyle,
      _ref$withFloatingUI = _ref.withFloatingUI,
      withFloatingUI = _ref$withFloatingUI === void 0 ? true : _ref$withFloatingUI;
  var dropdownRef = useRef(null);
  var sessionTokenRef = useRef();

  var _useState = useState(''),
      locationInputValue = _useState[0],
      onLocationInputChange = _useState[1];

  var _useState2 = useState(false),
      cardOverlay = _useState2[0],
      setCardOverlay = _useState2[1];

  useEffect(function () {
    if (inputProps !== null && inputProps !== void 0 && inputProps.value) {
      onLocationInputChange(inputProps === null || inputProps === void 0 ? void 0 : inputProps.value);
      setCardOverlay(true);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [onLocationInputChange]);
  var isScriptReady = useGmapsScript({
    libraries: "places&types=".concat(placesFilterTypes)
  });

  var _useRenderSuggestions = useRenderSuggestions({
    setCardOverlay: setCardOverlay,
    placesFilterTypes: placesFilterTypes,
    onSuggestionSelect: function onSuggestionSelect(placesData) {
      _onSuggestionSelect === null || _onSuggestionSelect === void 0 ? void 0 : _onSuggestionSelect(placesData);
      sessionTokenRef.current = null;
    },
    formId: formId,
    locationInputValue: locationInputValue,
    onLocationInputChange: onLocationInputChange,
    dropdownItemProps: dropdownItemProps,
    isScriptReady: isScriptReady,
    sessionTokenRef: sessionTokenRef
  }),
      renderSuggestions = _useRenderSuggestions.renderSuggestions;

  useOnClickOutside(dropdownRef, function () {
    return setCardOverlay(false);
  });
  var suggestionList = useMemo(function () {
    return locationInputValue ? /*#__PURE__*/_jsx(DropdownWrapper, {
      "data-cy": "address-suggestion-dropdown",
      dropdownSubWrapperStyle: dropdownSubWrapperStyle,
      children: renderSuggestions()
    }) :
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    _jsx(_Fragment, {});
  }, [dropdownSubWrapperStyle, locationInputValue, renderSuggestions]);
  var inputRef = useRef(null);

  var _useFloating = useFloating({
    placement: 'bottom',
    open: cardOverlay,
    onOpenChange: setCardOverlay,
    middleware: [offset(DROPDOWN_OFFSET), flip({
      padding: 5
    })],
    whileElementsMounted: autoUpdate,
    transform: true
  }),
      refs = _useFloating.refs,
      floatingStyles = _useFloating.floatingStyles;

  useEffect(function () {
    if (inputRef.current && autoFocus) inputRef.current.focus();
  }, [autoFocus, inputRef]);
  useEffect(function () {
    if (formValue) onLocationInputChange(formValue);
  }, [formValue, onLocationInputChange]);
  var handleInputChange = useCallback(function (value) {
    var _inputProps$onChange;

    if (value) setCardOverlay(true);else setCardOverlay(false);
    inputProps === null || inputProps === void 0 ? void 0 : (_inputProps$onChange = inputProps.onChange) === null || _inputProps$onChange === void 0 ? void 0 : _inputProps$onChange.call(inputProps, value);
    onLocationInputChange(value);
  }, [inputProps]);
  var inputLocationProps = useMemo(function () {
    return _objectSpread(_objectSpread(_objectSpread({
      type: 'text',
      placeholder: placeholder,
      id: formId,
      borderless: false,
      autoFocus: false,
      isFullwidth: true,
      disabled: disabled,
      value: locationInputValue
    }, helperText ? {
      helperText: /*#__PURE__*/_jsx(HelperTextRElement, {
        helperText: helperText
      })
    } : {}), inputProps), {}, {
      ref: inputRef,
      onChange: handleInputChange,
      testId: testId || 'google-auto-complete-input'
    });
  }, [disabled, formId, handleInputChange, helperText, inputProps, locationInputValue, placeholder, testId]);
  var inputTextEl = useMemo(function () {
    return /*#__PURE__*/_jsx("div", {
      ref: withFloatingUI ? refs.setReference : null,
      className: "reference",
      children: /*#__PURE__*/_jsx(TextInput, _objectSpread({}, inputLocationProps))
    });
  }, [inputLocationProps, refs.setReference, withFloatingUI]);
  var dropdownEl = useMemo(function () {
    return cardOverlay && suggestionList ? /*#__PURE__*/_jsx("div", {
      ref: withFloatingUI ? dropdownRef : null,
      "data-cy": dropdownTestId,
      children: /*#__PURE__*/_jsx(DropdownElementWrapper, {
        ref: withFloatingUI ? refs.setFloating : null,
        style: withFloatingUI ? floatingStyles : {},
        dropdownMainWrapperStyle: dropdownMainWrapperStyle,
        children: /*#__PURE__*/_jsxs(_StyledDiv, {
          id: "suggestion-4",
          children: [title && /*#__PURE__*/_jsxs(_StyledDiv2, {
            children: [/*#__PURE__*/_jsx(Title, {
              content: title,
              fontSize: "small",
              fontWeight: "semibold",
              twStyle: {
                "lineHeight": "19.5px"
              },
              textColor: "bold-purple"
            }), /*#__PURE__*/_jsx(Title, {
              content: subTitle,
              fontSize: "small",
              fontWeight: "normal",
              twStyle: {
                "lineHeight": "19.5px"
              },
              textColor: "gray-500"
            })]
          }), suggestionList]
        })
      })
    }) :
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    _jsx(_Fragment, {});
  }, [cardOverlay, dropdownMainWrapperStyle, dropdownTestId, floatingStyles, refs.setFloating, subTitle, suggestionList, title, withFloatingUI]);
  return /*#__PURE__*/_jsxs(MainWrapper, {
    mainWrapperStyle: mainWrapperStyle,
    children: [/*#__PURE__*/_jsx(FormLabelWrapper, {
      isFullWidth: true,
      id: formId,
      label: mainLabel,
      children: control ? /*#__PURE__*/_jsx(Controller, {
        name: formId,
        control: control,
        rules: {
          required: required
        },
        render: function render() {
          return inputTextEl;
        }
      }) : inputTextEl
    }), dropdownEl]
  });
};
export default GoogleAutoCompleteInput;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "google-auto-complete-input___StyledDiv",
  componentId: "sc-3y4wmj-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.25rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "google-auto-complete-input___StyledDiv2",
  componentId: "sc-3y4wmj-1"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.25rem",
  "borderBottomWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(229 231 235 / var(--tw-border-opacity))",
  "padding": "1rem"
});